export const SHOW_LOADING = 'show_loading';
export const HIDE_LOADING = 'hide_loading';



// WEBPACK FOOTER //
// ./src/redux/actions/types/loadingTypes.js